var map = {
	"./datetime-field.vue": "KlYR",
	"./email-field.vue": "wm5o",
	"./file-field.vue": "A8vP",
	"./input-field.vue": "29AK",
	"./label-field.vue": "o/ms",
	"./phone-field.vue": "3cwM",
	"./select-ajax-field.vue": "YQtv",
	"./select-field-empty.vue": "f2qk",
	"./select-field.vue": "T6JG",
	"./select2-ajax.vue": "pRhU",
	"./select2.vue": "R9Fo",
	"./select2empty.vue": "yB+n",
	"./stage-stamp.vue": "LCzY",
	"./switch-field.vue": "8/cu",
	"./switch-label.vue": "yt6z",
	"./textarea-field.vue": "FqeG"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UKqp";